import api from "@/lib/api";
import { printBillReceipt } from "@/lib/billPrint";

/**
 * Opens kitchen print dialogs immediately (sync, preserves user-gesture for POS clicks).
 */
export function printKotJobsImmediate(jobs = []) {
  if (!jobs?.length) return 0;

  let printed = 0;
  jobs.forEach((job) => {
    if (printBillReceipt(job, job.printer?.name)) {
      printed += 1;
    }
  });

  return printed;
}

/**
 * Sends jobs to station LAN printers in the background (non-blocking).
 */
export function dispatchKotJobsLan(jobs = []) {
  if (!jobs?.length) return Promise.resolve(null);

  return api.post("/kot/print-jobs", { jobs }).catch(() => null);
}

/**
 * Routes KOT jobs to station printers (LAN via API) with browser print fallback.
 * Used for KDS reprint where no user-gesture is required upfront.
 */
/** Print reprint jobs immediately and queue LAN dispatch (POS / KDS). */
export function runKotReprint(jobs = []) {
  const list = Array.isArray(jobs) ? jobs : jobs ? [jobs] : [];
  if (!list.length) return { printed: 0, jobs: [] };
  const printed = printKotJobsImmediate(list);
  dispatchKotJobsLan(list);
  return { printed, jobs: list };
}

export async function printKotJobs(jobs = []) {
  if (!jobs?.length) {
    return { printed: 0, results: [] };
  }

  try {
    const { data } = await api.post("/kot/print-jobs", { jobs });
    let printed = 0;

    for (const result of data.results || []) {
      if (result.dispatched) {
        printed += 1;
        continue;
      }
      if (result.job && printBillReceipt(result.job, result.job.printer?.name)) {
        printed += 1;
      }
    }

    return { printed, results: data.results || [], message: data.message };
  } catch {
    const printed = printKotJobsImmediate(jobs);

    return { printed, results: [], message: "Browser print fallback" };
  }
}
